import { checkWidthScreen } from './screen'

const getClassNames = isSelect => {
  const classes = {
    lines: name => `${name}-line`,
    plottedChartLine: 'plotted-chart-line',
    transparentChartLine: 'chart-line',
    chart: 'chart',
    mouse: 'mouse-over-effects',
    mousePerLine: 'mouse-per-line',
    mouseLine: 'mouse-line',
    circleColor: 'circle-color',
    yAxis: 'y-axis',
    xAxis: 'x-axis',
    tickText: 'tick text',
    domain: 'domain',
    groupArrow: 'group-arrow',
    groupMinus: 'group-minus',
    tooltip: {
      main: 'tooltip',
      name: 'tooltip-name',
      date: 'tooltip-date',
      value: 'tooltip-value',
      percent: 'tooltip-percent',
      compareText: 'tooltip-compare-text',
      color: 'tooltip-color'
    }
  }

  const classesWithInitialDot = JSON.parse(JSON.stringify(classes).replace(/:"/g, ':".'))
  classesWithInitialDot.lines = name => `.${name}-line`

  return isSelect ? classesWithInitialDot : classes
}

const CONSTANTS = {
  width: checkWidthScreen(window.innerWidth),
  height: 195,
  svgHeight: 300,
  numberOfTicks: 8,
  drawnPath: {
    groupArrow: [
      'M7.5 2.66602C7.84518 2.66602 8.125 2.96449 8.125 3.33268V12.666C8.125 13.0342 7.84518 13.3327 7.5 13.3327C7.15482 13.3327 6.875 13.0342 6.875 12.666V3.33268C6.875 2.96449 7.15482 2.66602 7.5 2.66602Z',
      'M2.68306 7.52925C2.92714 7.2689 3.32286 7.2689 3.56694 7.52925L7.5 11.7245L11.4331 7.52925C11.6771 7.2689 12.0729 7.2689 12.3169 7.52925C12.561 7.7896 12.561 8.21171 12.3169 8.47206L7.94194 13.1387C7.69786 13.3991 7.30214 13.3991 7.05806 13.1387L2.68306 8.47206C2.43898 8.21171 2.43898 7.7896 2.68306 7.52925Z'
    ],
    groupMinus:
      'M2.66666 7.99992C2.66666 7.63173 2.96513 7.33325 3.33332 7.33325H12.6667C13.0348 7.33325 13.3333 7.63173 13.3333 7.99992C13.3333 8.36811 13.0348 8.66659 12.6667 8.66659H3.33332C2.96513 8.66659 2.66666 8.36811 2.66666 7.99992Z'
  },
  chartWrapperElement: attrs => attrs.$$element.find('.data-frame-line-chart-svg')[0],
  xAxisFormats: {
    MONTHLY: '%b %y',
    DAILY: '%d %b %Y',
    WEEKLY: '%d %b'
  },
  arrowRotation: {
    positive: 180,
    negative: 0,
    'no-variation': -90,
    'no-available': 0
  },
  classNames: isSelect => getClassNames(isSelect),
  getXPositionFromBBox: (element, padding, widthWrapper, xPositionWrapper) => {
    const widthElement = element.getBBox().width

    return (widthWrapper - xPositionWrapper - padding) - widthElement
  },
  widthTooltip: 300,
  xPositionTooltip: 35,
  paddingTooltip: 10,
  percentOfTension: 0.85
}

export { CONSTANTS }
